<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1787_183097)">
<path d="M3.40381 3.40381L12.5962 12.5962" stroke="currentColor"/>
<path d="M12.5962 3.40381L3.4038 12.5962" stroke="currentColor"/>
</g>
</svg>
